import type { DialogStore } from '@ariakit/react'
import { ButtonLegacy } from '@/components/ui/button-legacy'
import {
	Dialog,
	DialogBody,
	DialogDismiss,
	DialogFooter,
	DialogHeader,
	DialogProvider
} from '@/components/ui/dialog-atoms'
import { Spinner } from '@/components/ui/spinner'
import { useTranslation } from '@/translations/i18n'

interface ProPhotosDeleteImageModalProps {
	store: DialogStore
	onDelete: (e: React.MouseEvent<HTMLButtonElement>) => void
	onClose: () => void
	isPending: boolean
}

export const ProPhotosDeleteImageModal = ({
	store,
	onDelete,
	isPending,
	onClose
}: ProPhotosDeleteImageModalProps) => {
	const { t } = useTranslation()

	return (
		<DialogProvider store={store}>
			<Dialog hideOnInteractOutside={!isPending} width={'480px'}>
				<DialogHeader className='border-b-0'>
					<DialogDismiss disabled={isPending} />
				</DialogHeader>
				<DialogBody className='gap-1'>
					<h3 className='font-medium text-neutral-900 text-xl'>
						{t('vetting:reordering.delete_photo_modal.title')}
					</h3>
					<p className='text-neutral-900 text-sm'>
						{t('vetting:reordering.delete_photo_modal.description')}
					</p>
				</DialogBody>
				<DialogFooter>
					<ButtonLegacy
						disabled={isPending}
						onClick={onClose}
						type='button'
						variant={'tertiary'}
					>
						{t('common:cancel')}
					</ButtonLegacy>

					<ButtonLegacy
						disabled={isPending}
						onClick={onDelete}
						type='button'
						variant={'primaryDanger'}
					>
						{t('vetting:reordering.delete_photo_modal.cta')}
						{isPending && <Spinner size={20} />}
					</ButtonLegacy>
				</DialogFooter>
			</Dialog>
		</DialogProvider>
	)
}
